import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BooleanFieldControlMessageMeta } from 'api/conversations';

export const BooleanControlMessage: FC<{
  meta: BooleanFieldControlMessageMeta;
  rootKey: string;
  userName: string;
}> = ({ meta, rootKey, userName }) => {
  let keyForString = rootKey;

  if (!meta.oldValue) {
    keyForString += '.ADDED';
  } else if (!meta.newValue) {
    keyForString += '.REMOVED';
  }

  if (meta.fieldName === 'atRisk') {
    keyForString += `.${meta.fieldName}`;
  }

  return (
    <FormattedMessage
      id={keyForString}
      values={{
        changedByUserName: userName,
        label: meta.fieldLabel || meta.fieldName,
        from: meta.oldValue,
        to: meta.newValue,
      }}
    />
  );
};
